module.exports = __webpack_public_path__ + "img/t3-teal.3bd123fd.png";